import Vue from 'vue'
import msal from 'vue-msal'

Vue.use(msal, {
  auth: {
    authority: process.env.VUE_APP_AUTHORITY,
    clientId: process.env.VUE_APP_CLIENT_ID,
    redirectUri: process.env.VUE_APP_REDIRECT_URI
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  },
  graph: {
    callAfterInit: true,
    endpoints: {
      profile: '/me',
    },
  }
});